export default __webpack_public_path__ + "static/maytronics-mineralswim-logo-88a7f79308ed31d48fea9245f49a28f3.png";